import React from 'react'
import AdmissionModule from './AdmissionModule'
import OfficeUseOnly from './OfficeUseOnly'

const AdmissionModuleEntireForm = () => {
  return (
    <div>
        <AdmissionModule />
        <OfficeUseOnly />
    </div>
  )
}

export default AdmissionModuleEntireForm